export const HomeApi = "https://api.consumet.org"
export const ServerApi = "https://animetrix-login-backend.vercel.app/api/v1"
export const StreamApi = "https://api.amvstr.ml"
